import { Button, Text } from '@chakra-ui/react';
import {
  DialogRoot,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogCloseTrigger,
  DialogTitle,
} from '@/components/ui/dialog';

interface TakeoverConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function TakeoverConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
}: TakeoverConfirmationModalProps) {
  return (
    <DialogRoot
      open={isOpen}
      onOpenChange={(e) => (e.open ? undefined : onClose())}
      closeOnInteractOutside={false}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Take Over Conversation</DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          <Text mb={4}>
            Are you sure you want to take over this conversation from the AI
            agent?
          </Text>

          <div className="bg-blue-50 p-3 border border-blue-200 rounded-md mb-4">
            <Text className="font-medium text-blue-700">After takeover:</Text>
            <Text className="text-sm text-blue-600 mt-1">
              • You will be able to communicate directly with the user
            </Text>
            <Text className="text-sm text-blue-600">
              • The AI agent will no longer respond automatically
            </Text>
            <Text className="text-sm text-blue-600">
              • You can hand the conversation back to the AI later if needed
            </Text>
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="outline" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={onConfirm}>
            Yes, Take Over
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
}
